export default {
    state: {
        apiUrl: process.env.NODE_ENV === 'development'
        ? 'http://localhost:8080/api'
        : process.env.REACT_APP_API_URL,
        apiKey: process.env.NODE_ENV === 'development'
        ? 'PuYxGevUt9ARJK0CKmEm04Gv0dQgFSTQ'
        : undefined
    },
    setApiUrl (url) {
        if (url !== '') {
            //this.state.apiUrl = url
            this.state.apiUrl = process.env.REACT_APP_API_URL
        }
    }
}
